(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-sta-offers"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.outboxOffersInit) return;
  window.outboxOffersInit = true;

  function copyCode(button) {
    var code = button.getAttribute('data-offer-code');
    if (!code) return;

    var label = button.querySelector('.product-offers__code-copy');
    var original = label ? label.textContent : '';

    var done = function () {
      button.classList.add('is-copied');
      if (label) label.textContent = 'Copied';
      window.clearTimeout(button._offersTimer);
      button._offersTimer = window.setTimeout(function () {
        button.classList.remove('is-copied');
        if (label) label.textContent = original || 'Copy';
      }, 5000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {
        fallbackCopy(code, done);
      });
    } else {
      fallbackCopy(code, done);
    }
  }

  function fallbackCopy(text, done) {
    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      done();
    } catch (e) {
      /* no-op: clipboard unavailable */
    }
    document.body.removeChild(input);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-offers__code');
    if (button) copyCode(button);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
